<template>
  <CCard>
    <CCardHeader>
      <div class="card-header-actions">
        <CButton variant="outline" color="success" @click="onReset" ref="reset-button" v-translate
                 translate-context="form" class="mr-2">Reset
        </CButton>
        <CButton color="primary" @click="onSave" ref="save-button">{{ save_text }}</CButton>
      </div>
    </CCardHeader>
    <CCardBody class="p-0">
      <CContainer fluid class="grid-stripped">
        <!-- Basic Info -->
        <PFRow :label="$pgettext('event_owner.label', 'Company Name')">
          <CInput v-model="form.company_name" :placeholder="$pgettext('event_owner.placeholder','Company Name')"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Third Level Domain')"
               :helpText="edit ? $pgettext('event_owner.help', 'Third level domain is read-only after creation') : $pgettext('event_owner.help', 'Unique subdomain identifier (lowercase, alphanumeric, hyphens)')">
          <CInput v-model="form.third_level_domain" :placeholder="$pgettext('event_owner.placeholder','domain')" :disabled="edit"/>
        </PFRow>

        <!-- Upload Settings -->
        <PFRow :label="$pgettext('event_owner.label', 'Upload Bucket Name')"
               :helpText="$pgettext('event_owner.help', 'S3 bucket name for uploads')">
          <CInput v-model="form.upload_bucket_name" :placeholder="$pgettext('event_owner.placeholder','bucket-name')"/>
        </PFRow>

        <!-- Display Options -->
        <PFRow :label="$pgettext('event_owner.label', 'Show Calendar')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.show_calendar"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Hide Cart')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.hide_cart"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Hide App Store Links')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.hide_app_store_links"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Hide Powered By Logo')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.hide_powered_by_logo"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Disable Social Login')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.disable_social_login"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Hide Events on Pica')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.hide_events_on_pica"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Hide Pica Events')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.hide_pica_events"/>
        </PFRow>

        <!-- Translatable Text Fields -->
        <PFRow :label="$pgettext('event_owner.label', 'Login Subtitle')"
               :helpText="$pgettext('event_owner.help', 'Custom subtitle shown on login page')">
          <PTranslatableTextInput v-model="form.login_subtitle" :placeholder="$pgettext('event_owner.placeholder','Login subtitle')"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Marketing Consent Description')">
          <PTranslatableCkeditor v-model="form.marketing_consent_description"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Hide Marketing Consent Last Update Date')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.hide_marketing_consent_last_update_date"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Face Checkin Privacy Statement')">
          <PTranslatableCkeditor v-model="form.face_checkin_privacy_statement"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Share Checkin Privacy Statement')">
          <PTranslatableCkeditor v-model="form.share_checkin_privacy_statement"/>
        </PFRow>

        <PFRow :label="$pgettext('event_owner.label', 'Footer Company Info')">
          <CTextarea v-model="form.footer_company_info" rows="3"/>
        </PFRow>
      </CContainer>
    </CCardBody>
  </CCard>

</template>

<script>
import PFRow from "@/domain/core/components/PFRow.vue";
import PTranslatableTextInput from "@/domain/core/components/PTranslatableTextInput.vue";
import PTranslatableCkeditor from "@/domain/core/components/PTranslatableCkeditor.vue";

export default {
  name: "Form",
  components: {PFRow, PTranslatableTextInput, PTranslatableCkeditor},
  props: {
    data: {
      type: Object,
      required: true
    },
    save_text: {
      type: String,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        company_name: '',
        third_level_domain: '',
        logo: null,
        login_subtitle: {},
        hide_cart: false,
        show_calendar: false,
        hide_app_store_links: false,
        hide_powered_by_logo: false,
        disable_social_login: false,
        hide_events_on_pica: false,
        hide_pica_events: false,
        marketing_consent_description: {},
        hide_marketing_consent_last_update_date: false,
        upload_bucket_name: '',
        face_checkin_privacy_statement: {},
        share_checkin_privacy_statement: {},
        footer_company_info: '',
      },
    }
  },
  computed: {},
  async mounted() {
    this.onReset()
  },
  emits: ['save'],
  methods: {
    onReset() {
      this.form = {...this.data}
    },
    async onSave() {
      this.$emit('save', this.form)
    }
  }
}
</script>
